export default __webpack_public_path__ + "static/media/student_report_icon.7c7227bc.svg";